/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTableInfo.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "common/TableInfo";

export class AutogenModelTableInfo<RowType extends ModelRow> extends Endpoint<RowType, RowTableInfoFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTableInfo extends ModelRow<RowTableInfoFields> {
	constructor(values?: Partial<RowTableInfoFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTableInfoFields {
	abbreviation: string;
	assigned_to: string;
	company_id: string;
	custom_table: string;
	descr: string;
	dev_application_id: string;
	dev_module_id: string;
	duplicate_of_table: string;
	indexspace_xref_id: string;
	lobspace_xref_id: string;
	name: string;
	primary_key_company_id_loc: string;
	row_class: string;
	status: string;
	tablespace_xref_id: string;
	upgrade_type: string;
	v6_name: string;
	workorder: number;
}

